import React, { Component } from "react";
import { Row, Col, FormGroup, FormControl } from "react-bootstrap";
import { connect } from "react-redux";
import {
  fetchSingleCatagory,
  fetchSingleFlower,
  sortFlower,
  containsSubCategory, 
  fetchAllCatagories
} from "../../redux/actions";
//import {Link} from 'react-router-dom'
import SingleCategoryPanel from "../singleCategory/singleCategoryPanel";
//import {browserHistory} from 'react-router';
import SubCategoryPanel from '../subcategories/subCategoryPanel'
import "./decoration.css";
import _ from 'lodash';
class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flowerData: [],
      category: this.props.catename,
      sortBy: "",
      loading:true,
      categoryloading: true,
      subcategories:undefined,
      subcategoryData:[]
    };
    this.handleSearchBarChange = this.handleSearchBarChange.bind(this);
  }

  componentDidMount() {
    containsSubCategory(this.props.catename).then((res)=>{
      if(res.data.length>0){
        this.setState({subcategoryData:res.data, loading:false, subcategories:true})
      }
      else{
        this.props.fetchSingleCatagory(this.props.catename).then(response => {
          let responseData = response.payload.data;
          if (responseData && responseData.length > 0) {
            this.setState({
              flowerData: responseData,
              loading:false,
              subcategories:false
            });
          }
        });
      }
    })

    this.props.fetchAllCatagories()
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps !== this.props) {
      this.setState({
        categoryloading: false
      });
      console.log(this.props)
    }
  };
  handleSearchBarChange = event => {
    let userInputValue = event.target.value;
    if (userInputValue.length > 0) {
      this.props.fetchSingleFlower(userInputValue).then(response => {
        let responseData = response.payload.data;
        if (responseData !== undefined && responseData.length > 0) {
          this.setState({
            flowerData: responseData
          });

          if (this.props.pathname === "/category/all") {
            let searchBar = document.querySelector(".searchBar");
            searchBar.style.width = "35%";
          }
        }
      });
    }
  };

  handleCategoriesSelect = event => {
    console.log('this props', this.props);
    this.setState({
      category: event.target.value
	});	
	window.location.href = event.target.value;
	
  };

  handleDefaultSortingSelect = event => {
    this.setState({
      sortBy: event.target.value
	});
	this.props.sortFlower(event.target.value, this.state.category).then(response => {
		let responseData = response.payload.data;
		if(responseData && responseData.length > 0){
			this.setState({
        flowerData: responseData,
        loading:false
			});		
		}
	});
  };
  renderOptions = () => {
    if (this.state.categoryloading === false) {  
    return _.map(this.props.categoryList, (name, index) => {
      return <option key={index} value={name.name}>{name.name}</option>
    })
    };
  } 
  render() {
    //let sortBy = this.state.sortBy;
    //let category = this.state.category;
    let preservedFlowerBoxDiv = null;
    if (this.props.pathname !== "/category/all" && !this.state.subcategories) {
      preservedFlowerBoxDiv = (
        <div className="AdvertiseBanner">
         <p id="bannerContentCh" />
          <Row className="show-grid">
            <Col sm={6} md={6} >
              <FormGroup controlId="formControlsSelect">
                <FormControl
                  componentClass="select"
                  placeholder="select"
				          onChange={event => this.handleDefaultSortingSelect(event)}
                >
                  <option value="defaultSorting">Default sorting</option>
                  <option value="newness">Sort by newness</option>
                  <option value="priceLowToHigh">
                    Sort by price: low to high
                  </option>
                  <option value="priceHighToLow">
                    Sort by price: high to low
                  </option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col sm={6} md={6}>
              <FormGroup controlId="formControlsSelect">
                <FormControl
                  componentClass="select"
                  placeholder="select"
				          onChange={event => this.handleCategoriesSelect(event)}
				          value={this.props.catename}
                >{ !this.state.categoryloading && this.renderOptions()}
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
        </div>
      )
    }
    else if (this.props.pathname !== "/category/all" && this.state.subcategories ){
      preservedFlowerBoxDiv = (
          <div className="AdvertiseBanner">
            <p id="bannerContentCh" />
              <FormGroup controlId="formControlsSelect">
                <FormControl
                    componentClass="select"
                    placeholder="select"
                    onChange={event => this.handleCategoriesSelect(event)}
                    value={this.props.catename}
                >{ !this.state.categoryloading && this.renderOptions()}
                </FormControl>
              </FormGroup>
            
          </div>
      );
    }
    if(this.state.loading){
      return (
         <div className="looding">
          <div className="boxLoding">
              <div id="loading2" />
          </div>
        </div>
      )
    }
    else{
      return (
        <div className='searchBarContainer'>
          {
            !this.state.subcategories ?
                <div className="searchBar" style={this.props.searchBarStyle}>
            <span>
              <i className="fa fa-search" aria-hidden="true" />
            </span>
                  <input
                      id="searchBar"
                      type="text"
                      placeholder="Search"
                      onChange={event => this.handleSearchBarChange(event)}
                  />
                </div>
                :
                null
          }
          {preservedFlowerBoxDiv}
          {
            this.state.subcategories ? <SubCategoryPanel subcategoryData={this.state.subcategoryData} catename={this.props.catename}/> : <SingleCategoryPanel flowerData={this.state.flowerData} catename={this.props.catename} />
          }
        </div>
      );
    }
    
  }
}

function mapStateToProps(state) {
  return {
    categoryList: state.catagorylist,
    shoppingCartItems: state.shoppingCartItems
    // userToken: state.userToken
  };
}

export default connect(
  mapStateToProps,
  { fetchSingleCatagory, fetchSingleFlower, sortFlower, fetchAllCatagories }
)(SearchBar);



// WEBPACK FOOTER //
// ./src/components/decoration/searchBar.js